import { useRef, useState } from "react";

const SWIPE_THRESHOLD_PX = 40;

export const useCarousel = (length) => {
  const [current, setCurrent] = useState(0);
  const touchStart = useRef(null);
  const next = () => setCurrent((p) => (p + 1) % length);
  const prev = () => setCurrent((p) => (p - 1 + length) % length);

  const swipeHandlers = {
    onTouchStart: (e) => {
      const t = e.touches[0];
      touchStart.current = { x: t.clientX, y: t.clientY };
    },
    onTouchEnd: (e) => {
      if (!touchStart.current) return;
      const t = e.changedTouches[0];
      const dx = t.clientX - touchStart.current.x;
      const dy = t.clientY - touchStart.current.y;
      touchStart.current = null;
      if (Math.abs(dx) < SWIPE_THRESHOLD_PX || Math.abs(dx) < Math.abs(dy)) return;
      dx < 0 ? next() : prev();
    },
  };

  return { current, setCurrent, next, prev, swipeHandlers };
};
